// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Components
import OrderNotify from "components/Notifications/order_notify";
// Infrastructure
import Tab01 from "views/Order/application/tabs/tab_01";
import Tab02 from "views/Order/application/tabs/tab_02";
import Tab03 from "views/Order/application/tabs/tab_03";
import Tabs from "views/Order/application/tabs/tabs";
import ResumeOrder from "views/Order/application/resume";
import { BillingAPI } from "views/Order/infrastructure";
// Vendor
import { getIncidencesDate, getServicesData } from "vendor/application";
import { showNotify } from "vendor/application/disptach";
import "views/Order/styles/index.scss";

class Billing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plan: "",
      products: [],
      statusOrder: "",
      currency: "euro",
      tax: "21",
      order: {
        concepts: [],
        period: "annual"
      },
      total: "",
      resume: {
        services: [],
        integrations: []
      },
      incidence: getIncidencesDate(),
      services: getServicesData(),
      tab: 1,
      request: { isDone: false, type: false }
    };
  }

  componentDidMount() {
    this.getProducts();
    this.handlePlan(this.props.plan);
  }

  getProducts = async () => {
    const { access } = this.props.data;
    try {
      const obj = new BillingAPI(null, access, this.props, null);
      let products = await obj.get_products();

      //TODO eliminar en un futuro cuando se permitan estos servicios
      var visible_products = [];
      products.forEach((product) => {
        if (
          ![
            "500_extra_mau",
            "centridesk_extra_agent",
            "zendesk_full",
            "zendesk_chat",
            "messenger"
          ].includes(product.name)
        ) {
          visible_products.push(product);
        }
      });
      this.setState({ products: visible_products });
    } catch (err) {
      var data = {
        message: "internal_server",
        from: "order",
        severity: "error"
      };
      this.props.dispatch(showNotify(data));
    }
    this.getOrder();
  };

  getOrder = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(user.account_id, access, this.props, null);
      var res = await obj.get_order();

      res.concepts.concepts = this.removeDuplicate(res.concepts);

      if (
        res.concepts.concepts.length > 0 &&
        res.concepts.concepts[0].name !== this.props.plan
      ) {
        this.deleteOrder(res.order_id);
      } else {
        var order = {
          concepts: res.concepts.concepts,
          period: res.period,
          order_id: res.order_id
        };
        this.handleResume(res.concepts.concepts, res.concepts.currency);
        this.setState({
          order: order,
          statusOrder: "put",
          total: {
            totalRenew: res.concepts.totals.renew.order,
            totalIva: res.concepts.totals.iva
              .toFixed(2)
              .toString()
              .replace(".", ","),
            totalOrder: res.concepts.totals.order,
            totalPrice: res.concepts.totals.total
              .toFixed(2)
              .toString()
              .replace(".", ","),
            totalDiscount: res.concepts.totals.total_discount
          }
        });
      }
    } catch (err) {
      this.handleOrderPlan();
      this.setState({ statusOrder: "post" });
    }
  };

  removeDuplicate = (res) => {
    return res.concepts.filter(
      (concept, i, s) =>
        i === s.findIndex((t) => t.reference === concept.reference)
    );
  };

  handleResume = (concepts, currency) => {
    this.state.resume.services = [];
    this.state.resume.integrations = [];
    concepts.forEach((concept) => {
      if (
        concept.name !== "500_extra_mau" &&
        concept.name !== "centridesk_extra_agent"
      ) {
        if (concept.reference.charAt(concept.reference.length - 1) === "S") {
          this.state.resume.services.push({
            name: concept.name,
            price: concept.total,
            taxable: concept.taxable_amount
          });
        } else if (
          concept.reference.charAt(concept.reference.length - 1) === "I"
        ) {
          this.state.resume.integrations.push({
            name: concept.name,
            price: concept.total,
            taxable: concept.taxable_amount
          });
        } else if (
          concept.reference.charAt(concept.reference.length - 1) === "P"
        ) {
          this.state.products.forEach((product) => {
            if (product.name === concept.name) {
              this.state.resume.plan = {
                annual: product.annual_price[currency],
                monthly: product.monthly_price[currency]
              };
            }
          });
        }
      }
    });

    this.setState({ resume: this.state.resume });
  };

  handleOrderPlan = () => {
    this.state.products.forEach((product) => {
      if (product.name === this.props.plan) {
        this.state.order.concepts.push({ reference: product.reference });
      }
    });

    this.setState({ order: this.state.order });
  };

  deleteOrder = async (id) => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(user.account_id, access, this.props, null);
      await obj.delete_order(id);
      this.handleOrderPlan();
      this.setState({ statusOrder: "post" });
    } catch (err) {}
  };

  handlePlan = (plan) => {
    this.setState({ plan: plan, order: this.state.order });
  };

  handleOrder = async () => {
    this.state.order.concepts = this.removeDuplicate(this.state.order);

    if (this.state.statusOrder === "post") {
      this.postOrder(this.state.order);
    } else {
      this.putOrder(this.state.order);
    }
  };

  postOrder = async (order) => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(user.account_id, access, this.props, order);
      let res = await obj.post_order();
      this.state.order.order_id = res.order_id;
      this.handleResume(res.concepts, res.currency);
      this.setState({
        statusOrder: "put",
        total: {
          totalRenew: res.totals.renew.order,
          totalIva: res.totals.iva.toFixed(2).toString().replace(".", ","),
          totalOrder: res.totals.order,
          totalPrice: res.totals.total.toFixed(2).toString().replace(".", ","),
          totalDiscount: res.totals.total_discount
        }
      });
    } catch (err) {
      var data = { message: err, from: "order", severity: "error" };
      this.props.dispatch(showNotify(data));
    }
  };

  putOrder = async (order) => {
    const { access, user } = this.props.data;

    try {
      const obj = new BillingAPI(user.account_id, access, this.props, order);
      let res = await obj.put_order(this.state.order.order_id);
      this.handleResume(res.concepts, res.currency);
      this.setState({
        total: {
          totalRenew: res.totals.renew.order,
          totalIva: res.totals.iva.toFixed(2).toString().replace(".", ","),
          totalOrder: res.totals.order,
          totalPrice: res.totals.total.toFixed(2).toString().replace(".", ","),
          totalDiscount: res.totals.total_discount
        }
      });
    } catch (err) {
      var data = {
        message: err.responseJSON.message,
        from: "order",
        severity: "error"
      };
      this.props.dispatch(showNotify(data));
    }
  };

  postContract = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(user.account_id, access, this.props);
      await obj.post_contract(this.state.order.order_id);
      this.handleTabsComponents(3);
    } catch (err) {
      var data = {
        message: err.responseJSON.message,
        from: "order",
        severity: "error"
      };
      this.props.dispatch(showNotify(data));
    }
  };

  handleAction = (e) => {
    e.preventDefault();
    switch (this.state.request.type) {
      case "error":
        this.setState({ request: { isDone: false, type: "" } });
        break;
      case "success":
        this.props.history.push("/");
        break;
    }
  };

  updatePeriod = (e) => {
    e.preventDefault();
    if (this.state.order.period === "monthly") {
      this.state.order.period = "annual";
    } else {
      this.state.order.period = "monthly";
    }

    this.setState({ order: this.state.order });
    this.handleOrder();
  };

  handleTabs = (e, i) => {
    e.preventDefault();
    this.setState({ tab: i });
  };

  handleTabsComponents = (i) => {
    this.setState({ tab: i });
    this.getOrder();
  };

  updateCurrency = (currency, tax) => {
    this.setState({ currency: currency, tax: tax });
  };

  isInOrder = (reference) => {
    var res = false;
    this.state.order.concepts.forEach((element) => {
      if (element.reference === reference) {
        res = true;
      }
    });

    return res;
  };

  updateOrder = (e, reference) => {
    var exist = this.isInOrder(reference);

    if (!exist) {
      this.state.order.concepts.push({ reference: reference });
    } else {
      this.state.order.concepts.forEach((el, i) => {
        if (el.reference === reference) {
          this.state.order.concepts.splice(i, 1);
        }
      });
    }

    this.setState({ order: this.state.order });
    this.handleOrder();
  };

  render() {
    const {
      plan,
      request,
      tab,
      products,
      order,
      currency,
      total,
      resume,
      tax
    } = this.state;

    const { t } = this.props;
    return (
      <React.Fragment>
        {!request.isDone ? (
          plan &&
          products &&
          products.length > 0 && (
            <React.Fragment>
              <div className="man-order">
                <div className={this.props.plan}>
                  <div className={`man-header ${this.props.plan}`}>
                    <div>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: t(`plans:${plan}.name`)
                        }}
                      ></p>
                    </div>
                  </div>
                  <div className="man-content">
                    <Tabs plan={this.props.plan} tab={tab} />
                    <div className="man-sub_content buy">
                      <Tab01
                        tab={tab}
                        currency={currency}
                        t={t}
                        handleTabsComponents={this.handleTabsComponents}
                        existResume={resume.plan}
                        handleOrder={this.handleOrder}
                        updateCurrency={this.updateCurrency}
                        getOrder={this.getOrder}
                      />
                      <Tab02
                        tab={tab}
                        currency={currency}
                        t={t}
                        handleTabs={this.handleTabs}
                        postContract={this.postContract}
                        plan={this.props.plan}
                        order={order}
                        resume={resume}
                        products={products}
                        isInOrder={this.isInOrder}
                        updateOrder={this.updateOrder}
                        updatePeriod={this.updatePeriod}
                      />
                      <Tab03
                        tab={tab}
                        currency={currency}
                        t={t}
                        handleTabs={this.handleTabs}
                        plan={this.props.plan}
                        order={order}
                        resume={resume}
                        order_id={order.order_id}
                      />
                    </div>
                  </div>
                </div>
                <ResumeOrder
                  t={t}
                  plan={plan}
                  planName={this.props.plan}
                  order={order}
                  currency={currency}
                  total={total}
                  resume={resume}
                  tax={tax}
                />
              </div>
            </React.Fragment>
          )
        ) : (
          <div className="man-order notify">
            <div className={this.props.plan}>
              <div className={`man-header mobile-header ${this.props.plan}`}>
                <div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: t(`plans:${plan}.name`)
                    }}
                  ></p>
                </div>
              </div>
              <div className="man-content">
                <OrderNotify
                  domain={"order"}
                  onClick={this.handleAction}
                  type={request.type}
                  error={request.error}
                />
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_ = connect(mapStateToProps)(Billing);
export default withTranslation(["order", "inputs", "plans"])(
  withRouter(connect_)
);
